import * as React from "react";
import { Modal, Form, Select } from "antd";
import { IFormVersion } from "../../../model/form/FormVersion";

const { Option } = Select;

export interface State {}

export interface Props {
  visible?: boolean;
  onChange: any;
  formVersionList: IFormVersion[];
  translate: any;
  onSelectCompareVersions: any;
  compareVersionsSelected?: number[];
  getComparisonFormVersionsDetails: any;
  loading?: boolean;
}

export default class ComapreVersionsDialog extends React.Component<
  Props,
  State
> {
  render() {
    const {
      visible,
      onChange,
      translate,
      formVersionList,
      onSelectCompareVersions,
      compareVersionsSelected,
      getComparisonFormVersionsDetails,
      loading
    } = this.props;

    const hasErrors = () => {
      return (
        compareVersionsSelected &&
        (compareVersionsSelected.length > 2 || formVersionList.length < 2)
      );
    };

    const renderErrorMessage = (errorMessage: string) => {
      return <div style={{ marginTop: 2 }}>{errorMessage}</div>;
    };

    return (
      <Modal
        title={translate("compare_versions.modal_title")}
        visible={visible}
        onOk={() => getComparisonFormVersionsDetails()}
        onCancel={() => onChange(false)}
        okButtonProps={{
          disabled:
            hasErrors() ||
            (compareVersionsSelected && compareVersionsSelected.length < 2)
              ? true
              : false,
          loading: loading
        }}
        okText={translate("modal_functions.compare_modal.compare")}
        cancelText={translate("modal_functions.compare_modal.cancel")}
      >
        <Form.Item
          label={translate("compare_versions.modal_content")}
          validateStatus={hasErrors() ? "error" : undefined}
          help={
            hasErrors() &&
            renderErrorMessage(
              formVersionList.length < 2
                ? translate(
                    "compare_versions.err_message_not_enough_form_versions"
                  )
                : translate("compare_versions.err_message")
            )
          }
        >
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder={translate("compare_versions.placeholder")}
            onChange={onSelectCompareVersions}
            value={compareVersionsSelected}
            notFoundContent={translate("search.no_data")}
          >
            {formVersionList.map(item => (
              <Option key={item.id} value={item.id}>
                {item.version} - {item.status}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Modal>
    );
  }
}
